module.exports = __webpack_public_path__ + "img/upload-item-cancel.b644c176.svg";